<template>
  <div class="kpt-zone-detail" v-if="zone">
    <div v-if="zone && !loading">
      <header>
        <span class="kpt-zone-detail-title">
          <span class="has-text-grey">Zone: </span> 
          <strong class="kpt-zone-detail-title-text" v-if="!editZoneNameOpen">{{zone.name}}</strong>
          <b-input v-if="updateZone" size="is-small" type="text" v-model="updateZone.name" v-else></b-input>
        </span>
        <span class="buttons">
          <b-button type="is-primary" size="is-small" icon-left="save" v-if="editZoneNameOpen" @click="saveZoneName" :loading="isSavingName">Save</b-button>
          <button @click="toggleEdit">Edit</button>
          <!-- <b-button :type="!editZoneNameOpen ? 'is-primary' : 'is-light'" size="is-small" :icon-left="editZoneNameOpen ? 'times' : 'edit'" @click="toggleEdit">
            <span v-if="!editZoneNameOpen">Edit</span>
            <span v-else>Cancel</span>
          </b-button> -->
        </span>
      </header>
      <main>
        <zone-action :action="action" v-for="(action, idx) in zone.actions" :key="idx"></zone-action>
        <div class="kpt-zone-detail-add-action">
          <a><font-awesome-icon :icon="['far', 'plus']" @click="addZoneAction = !addZoneAction" title="Add Zone Action" class="has-cursor-pointer" /> Add Action</a>
        </div>
      </main>
    </div>
    <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false" v-else></b-loading>  
  </div>
</template>
<script>
import ZoneAction from './ZoneActionComponent.vue';

export default {
  name: 'ZoneDetail',
  data() {
    return {
      editZoneNameOpen: false,
      updateZone: null,
      isSavingName: false,
      addZoneAction: false
    }
  },
  components: {
    ZoneAction
  },
  props: {
    zone: Object,
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'zone': function (newvalue, oldvalue) {
      this.updateZone = JSON.parse(JSON.stringify(this.zone));
    }
  },
  methods: {
    async saveZoneName() {
      this.isSavingName = true;
      await this.$store.dispatch('updateZone', { id: this.zone.id, name: this.updateZone.name });
      this.isSavingName = false;
      this.editZoneNameOpen = false;
    },
    toggleEdit() {
      this.editZoneNameOpen = !this.editZoneNameOpen;
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/_colors';
.kpt-zone-detail {
  overflow-y: auto;
  background: $white;
  flex: 1 0 auto;
  position: relative;
  width: 400px;
  margin: -10px -10px -15px;

  header {
    padding: 7px 12px;
    border-bottom: 2px solid $grey-lighter;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .kpt-zone-detail-title {
      display: flex;
      align-items: center;

      .control {
        margin-left: 8px;
        margin-right: 8px;
      }

      .kpt-zone-detail-title-text {
        margin-left: 5px;
      }
    }
  }

  main {
    .kpt-zone-detail-add-action {
      padding: 12px;
      text-align: center;
    }
  }
}
</style>
